 
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { userActions } from '../../actions/user.actions';
import axiosInstance from '../../helpers/axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import user1 from '../../assets/images/user.png';
import {
  Card, Input
} from 'reactstrap';
 

import submitActivity from '../../assets/images/submitActivity.png';
import send from '../../assets/images/send.png';
import './index.css';
import { useCurrentUser } from '../../hooks/useCurrentUser';
export default function Activity() {
  const dispatch=useDispatch()
  const decode = useCurrentUser();
  const user = null;
  const getActivityState=useSelector((state)=>state?.ACTIVITY?.activityData)
  const { activityAppId, activityUserId, activityAppLoanId, activityAppLegacyLoanId, status: appContextStatus } = useSelector((state) => state.appContext);
  const [activityDetails,setActivityDetails]=useState(null)
  const [activityDetailsLoan,setActivityDetailsLoan]=useState(null)
  const urlAddActivity=`/audit`
  const urlLoanAddActivity=`/loan-repayment/activity`
  const getActivityUrl=`/audit?applicationId=${activityAppId}`
  const getActivityUrlLoan=`/loan-repayment/activity?applicationId=${activityAppId}`

  useEffect(() => {
     const ref = document.getElementById('chatcontent');
      setTimeout(()=> {
        ref.scrollTop = ref.scrollHeight;
      }, 100);
      if(getActivityState?.res?.data?.data.length>0){
        setActivityDetails(getActivityState?.res?.data?.data)
      }
      else{
        dispatch(userActions.getActivity(getActivityUrl,user))
      }

  }, [getActivityState])

  useEffect(() => {
      if(appContextStatus==='Disbursed'){
        const ref = document.getElementById('chatcontent');
        axiosInstance.get(getActivityUrlLoan, {
          headers: {
          },
        }).then((res)=>{
          setTimeout(()=> {
            ref.scrollTop = ref.scrollHeight;
          }, 100);
          setActivityDetailsLoan(res?.data?.data)
          })
      }
  }, [])
  

  const [activityDescrition,setActivityDescription]=useState(null)



  async function handlegetActivity(){
    const ref = document.getElementById('chatcontent');
    axiosInstance.get(getActivityUrlLoan, {
      headers: {
      },
    }).then((res)=>{
      setTimeout(()=> {
        ref.scrollTop = ref.scrollHeight;
      }, 100);
      setActivityDetailsLoan(res?.data?.data)
      })
    
}

  async function handlePostLoanActivity(){
    setActivityDescription(null)
    document.getElementById('descriptionBox').value=null
    const now = new Date();
const dateTime = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now
  .getDate()
  .toString()
  .padStart(2, '0')} ${now.getHours().toString().padStart(2, '0')}:${now
  .getMinutes()
  .toString()
  .padStart(2, '0')}:${now.getSeconds().toString().padStart(2, '0')}`;
    const activityBody={
        "legacyLoanId" :activityAppLegacyLoanId,
        "loanId" :activityAppLoanId,
        "userId": activityUserId,
        "notes": activityDescrition,
        "date": dateTime,
        "amount":''
    }
  axiosInstance.post(urlLoanAddActivity,activityBody, {
    headers: {
    },
  }).then((res) => {
    if (res.status === 200) {
      handlegetActivity(); // Call the function only if status is 200
    } else {
    }
  })
  .catch((error) =>{ console.error("Error in handlegetActivity:", error.message)
    if(error.message==='Request failed with status code 403'){
     alert('You are not authorized to access this resource.');
    } else {
     alert('Something went wrong. Please try again or contact support team.');
   }
   
   
   })
   }







  async function handleSubmitActivity(){
    setActivityDescription(null)
    document.getElementById('descriptionBox').value=null
    const activityBody={
       "userId": activityUserId,
        "status": "Notes Created",
        "notes": activityDescrition,
        "applicationId": activityAppId
    }
     await dispatch(userActions.submitActivity(urlAddActivity,activityBody,user))
     
  }
   
  return (
     <>
  
   <Card className="card" style={{width:"100%",height:'100%'}} >
        
            <div className="chatContainer">
            
              <div id="chatcontent" style={{overflowY: 'scroll',height:'85%'}}>
              {
            
            activityDetails?.map((item)=>{
  
                  if(decode?.email!==item.doneBy)
                  {
  
                    return(
                      <div className="receiver" style={{marginLeft:'1em',

                        ...((item.doneBy === 'system') && { backgroundColor: '#F0E7FD',border: '2px solid #D3C4EC' })
                      }}>
              
                  <p style={{marginTop:'-4em', display: 'flex',alignItems: 'center',flexWrap: 'nowrap', whiteSpace: 'nowrap'  }} ><img src={user1} alt="" style={{marginRight:'1em'}}/><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em'}} >{item.doneBy}</span><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em',color:'#989898'}} >{item.createdAt} </span></p>
                  <p><span style={{fontWeight:'bold'}}>Status :</span> {item.status}</p>
                    {item.notes}
                  </div>
                    )
                  
                  }
                  else{
                    
                    return(
  
                    <div className="sender" >
                      <p style={{marginTop:'-4em',right:'4em'}} ><img src={user1} style={{marginRight:'1em'}} alt=""/><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em'}} >{item.doneBy}</span><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em',color:'#989898'}} >{item.createdAt} </span></p>
                    <p><span style={{fontWeight:'bold'}}>Status : </span> {item.status}</p>
                     {item.notes}
                   </div>
                    )
                     
                    }
              })
              
            }
            {
        activityDetailsLoan?.filter(item => 
              !item.notes?.includes("IVR Notification sent to user") && 
              !item.notes?.includes("Call Date:")
            )?.map((item)=>{

                      if(decode?.email!==item.doneBy)
                      {

                        return(
                          <div className="receiver"
                          style={{marginLeft:'1em',

                            ...((item.doneBy === 'system' || item.doneBy === null) && { backgroundColor: '#F0E7FD',border: '2px solid #D3C4EC' }) 
                          }}
                          >

                      <p style={{marginTop:'-4em'  }} ><img src={user1} alt="" style={{marginRight:'1em'}}/><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em'}} >{item.doneBy}</span><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em',color:'#989898'}} >{item.created_at} </span></p>
                      {/* <p><span style={{fontWeight:'bold'}}>Status :</span> {item.status}</p> */}
                      {item.doneBy === 'system' ? (
                            <>
                              <p><span style={{fontWeight:'bold'}}>CreatedAt:</span> {item.created_at}</p>
                              <p><span style={{fontWeight:'bold'}}>Amount:</span> {item.amount}</p>
                              <p><span style={{fontWeight:'bold'}}>Paid Date:</span> {item.updated_at}</p>
                              <p><span style={{fontWeight:'bold'}}>Notes:</span> {item.notes}</p>
                            </>
                          ) : (
                            <p><span style={{fontWeight:'bold'}}>Notes:</span> {item.notes}</p>
                          )}
                      </div>
                        )

                      }
                      else{
                        
                        return(

                        <div className="sender">
                          <p style={{marginTop:'-4em'}} ><img src={user1} alt="" style={{marginRight:'1em'}}/><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em'}} >{item.doneBy}</span><span style={{fontWeight:'bold',fontSize:'18px',marginRight:'1em',color:'#989898'}} >{item.created_at} </span></p>
                        {/* <p><span style={{fontWeight:'bold'}}>Status : </span> {item.status}</p> */}
                        <p><span style={{fontWeight:'bold'}}>notes : </span> {item.notes}</p>
                        
                      </div>
                        )
                        
                        }
                      })

                      }           
                   </div>
          {appContextStatus==='Disbursed' && activityAppLegacyLoanId !== null  ?
           
          <div style={{borderRadius:'12px' ,marginTop:'1em',border:'1px solid #E7BABC',backgroundColor:'#FFEDEE',padding:'1em',display:'flex',justifyContent: 'space-between',}}>
            <Input id="descriptionBox" style={{width:'83%'}} onChange={(e)=>setActivityDescription(e.target.value)} type='text' placeholder="Log Activity Here"/>
            <div onClick={()=>handlePostLoanActivity()} style={{cursor:'pointer',marginLeft:'10px'}} >
              <img style={{position:'absolute',padding:'0.8em'}} src={send} alt=""/>
              <img src={submitActivity} alt=""/>
            </div>
          </div>:
           <div style={{borderRadius:'12px' ,marginTop:'1em',border:'1px solid #E7BABC',backgroundColor:'#FFEDEE',padding:'1em',display:'flex',justifyContent: 'space-between',}}>
           <Input id="descriptionBox" style={{width:'83%'}} onChange={(e)=>setActivityDescription(e.target.value)} type='text' placeholder="Log Activity Here"/>
           <div onClick={()=>handleSubmitActivity()} style={{cursor:'pointer',marginLeft:'10px'}} >
             <img style={{position:'absolute',padding:'0.8em'}} src={send} alt=""/>
             <img src={submitActivity} alt=""/>
           </div>
         </div>
          
        
        }
    </div>
         
  </Card>
  </>
    
  )
}
